import * as core from '../../../../../../../core'
import * as organizationHealthCheck from '../organization-health-check'

export const RESOURCE = {
  payload: {
    alias: 'overview',
    appAlias: organizationHealthCheck.RESOURCE.payload.alias,
    description:
      'Shows an overview of all Health Checks for a given organization, with the ability to drill down to all levels of a health check.',
    display: {
      isMain: true,
      position: 1,
    },
    name: 'Overview',
    page: { alias: 'overview' },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
